import {toCamelCase} from '@s-ui/js/lib/string'

export const getInitialProps = async ({
  routeInfo,
  context: {
    domain,
    i18n: {culture}
  }
}) => {
  const {
    location: {pathname: path}
  } = routeInfo
  const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})
  const getSeoData = () => domain.get('get_seo_data_use_case').execute({culture, pageName})
  const [seoDataError, {head: helmet} = {}] = await getSeoData()
  const config = domain.get('config')
  const markdownProps = {
    tenant: config.get('TENANT'),
    documentName: toCamelCase(pageName)
  }

  return {
    helmet,
    pageName,
    seoDataError,
    markdownProps
  }
}
